import { getTheme } from '@phishtool/ui';
export default getTheme();
